var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"首页","name":"first","lazy":true}},[_c('GlobalProfile')],1),_c('el-tab-pane',{attrs:{"label":"慢性病画像","name":"second","lazy":true}},[_c('ChronicDiseaseView')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }